module.exports = __webpack_public_path__ + "img/armaBoca.9e894081.jpg";